import { withTranslatedMeta, withRouter } from 'i18n/utils'
import { lastBookingLinkSelector } from 'booking/selectors'
import VehicleList from 'dashboard-vehicles/components/VehicleList'
import VehicleForm from 'dashboard-vehicles/components/VehicleForm'
import Button from '@components/Button'

import './styles.scss'

const VehiclesView = ({ lastBookingLink, history }) => (
    <div className="container vehicles-container dashboard-inner-container">
        {lastBookingLink && (
            <Button className="mb-4" btnStyle="link" iconLeft="arrow-left" onClick={() => history.goBack()}>
                <T>dashboard.button.back-to-booking</T>
            </Button>
        )}
        <h3 className="font-weight-bold">
            <T>dashboard.menu.vehicles</T>
        </h3>
        <VehicleList />

        <h3 className="font-weight-bold">
            <T>dashboard.vehicles.add.label</T>
        </h3>
        <VehicleForm />
    </div>
)

const mapStateToProps = createStructuredSelector({
    lastBookingLink: lastBookingLinkSelector,
})

export default compose(
    withRouter,
    withTranslatedMeta('dashboard.menu.vehicles'),
    connect(mapStateToProps)
)(VehiclesView)
